const mContentNodeBlockDocument = {
  mContentNodeBlockDocument: {
    alerts: {
      showDownloadState: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        downloading: 'Descargando Archivo...',
        downloaded: '¡Descarga Completada!'
      }
    }
  }
}

export default mContentNodeBlockDocument
